import { type StatusBar as UIStatusBar } from "@gluestack-ui/themed";

type UIStatusBarProps = React.ComponentProps<typeof UIStatusBar>;

export enum StatusBarVariantEnum {
  DEFAULT = "default",
  GREEN = "green",
  LIGHT = "light",
  DARK = "dark",
  STORE_SELECT = "store-select",
  HOME = "home",
  CAMERA = "camera"
}

export interface StatusBarProps extends UIStatusBarProps {
  showCustomStatusBar?: boolean;
  statusBarVariant?: StatusBarVariantEnum;
}
